import React from 'react';

const LogoC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" id="C" version="1.1" viewBox="0 0 1024 1024">
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="239.5"
        x2="956.2"
        y1="961"
        y2="11.3"
        gradientTransform="matrix(1 0 0 -1 0 1024)"
        gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#98c7ff"></stop>
        <stop offset="0" stopColor="#c4b4fe"></stop>
        <stop offset="0.3" stopColor="#ffd6ef"></stop>
        <stop offset="0.5" stopColor="#dfebff"></stop>
        <stop offset="0.6" stopColor="#ffedea"></stop>
        <stop offset="0.9" stopColor="#98c7ff"></stop>
      </linearGradient>
      <linearGradient
        id="linear-gradient1"
        x1="197.3"
        x2="914"
        y1="929"
        y2="-20.7"
        gradientTransform="matrix(1 0 0 -1 0 1024)"
        gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#98c7ff"></stop>
        <stop offset="0" stopColor="#d4b5ff"></stop>
        <stop offset="0.3" stopColor="#ffe3f4"></stop>
        <stop offset="0.4" stopColor="#f4edf9"></stop>
        <stop offset="0.6" stopColor="#c2d8ff"></stop>
        <stop offset="0.8" stopColor="#ffc2c4"></stop>
      </linearGradient>
      <clipPath id="clippath">
        <path
          fill="none"
          d="M809.1 178.2s22.3 191.4 16.5 217.6c0 0-.3 5.8-14.1 5.9 0 0-3 2.2-11.8-30.6S733.9 164.5 568 172.3c0 0-70.4-6.3-132.9 54.1s-89.8 206.7-85.9 283.5 4.2 342.5 231.7 336.4 221.9-143.5 221.9-143.5.4-4.7 4.7-4.7 5.1 4.7 5.1 4.7 2.4 172.3-242.3 170.5-375-145-372.9-357.6 147.8-364.9 359.9-364.6c0 0 78.7-7.3 198.5 40.7 0 0 10.6 5.8 12.3 1 0 0 21.9-34.1 24.5-32.4 0 0 14.1-3.3 16.5 17.6z"></path>
      </clipPath>
    </defs>
    <path
      fill="url(#linear-gradient)"
      d="M809.1 178.2s22.3 191.4 16.5 217.6c0 0-.3 5.8-14.1 5.9 0 0-3 2.2-11.8-30.6S733.9 164.5 568 172.3c0 0-70.4-6.3-132.9 54.1s-89.8 206.7-85.9 283.5 4.2 342.5 231.7 336.4 221.9-143.5 221.9-143.5.4-4.7 4.7-4.7 5.1 4.7 5.1 4.7 2.4 172.3-242.3 170.5-375-145-372.9-357.6 147.8-364.9 359.9-364.6c0 0 78.7-7.3 198.5 40.7 0 0 10.6 5.8 12.3 1 0 0 21.9-34.1 24.5-32.4 0 0 14.1-3.3 16.5 17.6z"></path>
    <g clipPath="url(#clippath)">
      <path fill="url(#linear-gradient1)" d="M192.5 145.8h639.1v732.6H192.5z"></path>
    </g>
  </svg>
);

export default LogoC;
